import './App.css';
import { useState } from 'react';
import styled from 'styled-components';
import AboutWindow from './AboutWindow';
import Sidebar from './Components/Sidebar';
import Footer from './Components/Footer';
import LearnMore from './Components/LeanMore';

const ProductGrid = styled.div`
  display: grid;
  grid-template-columns: repeat(2, 1fr);
  gap: 2rem;
  max-width: 1200px;
  padding: 0 2rem 2rem 2rem;
  margin: 0 auto;

  @media (max-width: 777px) {
    grid-template-columns: repeat(auto-fit, minmax(280px, 1fr));
  }
`;

const ProductCard = styled.div`
  border: 2px solid black;
  padding: 1rem;
  background: white;
  display: flex;
  flex-direction: column;
  align-items: center;
  font-family: "Pixelify Sans", sans-serif;
`;

const ProductImage = styled.img`
  max-width: 100%;
  height: auto;
`;

const Select = styled.select`
  font-family: "Pixelify Sans", sans-serif;
  padding: 0.5rem;
  margin: 1rem 0;
  border: 2px solid black;
`;

const Button = styled.button`
  font-family: "Pixelify Sans", sans-serif;
  background: black;
  color: white;
  border: none;
  padding: 0.5rem 1rem;
  margin: 0.5rem;
  cursor: pointer;
  &:hover {
    opacity: 0.8;
  }
  &:disabled {
    cursor: not-allowed;
    opacity: 0.4;
  }
`;

const ProductTitle = styled.h3`
  margin: 1rem 0;
  font-family: "Pixelify Sans", sans-serif;
`;

const CartBadge = styled.div`
  position: relative;
  display: inline-block;
`;

const Badge = styled.div`
  position: absolute;
  bottom: 2px;
  right: -4px;
  background: black;
  color: white;
  border-radius: 50%;
  width: 16px;
  height: 16px;
  font-size: 12px;
  display: flex;
  align-items: center;
  justify-content: center;
  font-family: "Pixelify Sans", sans-serif;
`;

const products = [
  { id: 1, name: 'K cap', price: '$75', file: '/hat.glb', image: '/khat.png', types: ['S', 'M', 'L'] },
  { id: 2, name: 'sftr bag', price: '$90', file: '/sftrbag.glb', image: '/stealbag.png', types: ['white', 'black'] },
  { id: 3, name: 'which/one tee', price: '$65', file: '/whichshirt.glb', image: '/whichtee.png', types: ['S', 'M', 'L', 'XL'] },
  { id: 4, name: 'sftr shirt', price: '$65', file: '/sftrshirt.glb', image: '/stealshirt.png', types: ['S', 'M', 'L', 'XL'] },
];

const productInfo = [
  { 
    id: 1, 
    name: 'K cap', 
    price: '$75', 
    vid: '/khat.mp4', 
    types: ['S', 'M', 'L'],
    description: [
      "The 'Linawag ng Kalayaan,' or 'Light of Freedom,' is a symbol that almost became the Philippine flag.",
      "Prior to that, it served as the symbol of the secret society of freedom fighters called the 'Katipunero', who fought against the island nation's colonization from Spanish forces in the 1800s. The eight-rayed sun tells the story of the innocents, martyrs, and heroes in the eight provinces of 1896, and to this day remains a symbol of the enlightened fighting spirit throughout dark, ignorant times.",
      "Lit ☀."
    ]
  },
  { 
    id: 2, 
    name: 'SFTR bag', 
    price: '$90', 
    vid: '/stealbag.mp4', 
    types: ['white', 'black'],
    description: [
      'Wealth inequality accounts for major problems for both individual and societal health. It might be time to admit that there is a critical "bug" in our culture\'s incentivization "software" that has led to the formation of this ever growing wealth chasm between the top 1% and the rest of us. We pay for luxury at the expense of every day necessities. The more we have, the less it seems to matter as the commodification of life continues.',
      'This handbag design is an ironic quiet protest against the meaningless wealth symbology that pervades modern life. Repurposing, stealing, the status symbols of the elite in a bit of harmless satire isn\'t a crime... is it?'
    ]
  },
  { 
    id: 3, 
    name: 'which/one tee', 
    price: '$65', 
    vid: '/whichshirt.mp4', 
    types: ['S', 'M', 'L'],
    description: [
      "Nuclear weapons may possibly be the most destructive technology invented in the last century, but modern nuclear power plants can deliver green, fossil-fuel independent energy.",
      "Our technology gives us super human abilities to learn, save time, and decentralize power and economic structures towards a more equitable world, but it can also enslave us in paranoid social media doom loops, competing for ethereal likes and nonsense digital value traps, in tribal echo-chambers controlled by indifferent algorithms with the sole imperative being to maximize rage-baited engagement for empty profits and feeding creativity-sapping AI facades.",
      "There's often a thin human-made line between paradise and oblivion.", 
      "Which world do we want? Which world do we create?"
    ]
  },
  { 
    id: 4, 
    name: 'SFTR shirt', 
    price: '$65', 
    vid: '/stealshirt.mp4', 
    types: ['S', 'M', 'L', 'XL'],
    description: [
      'Wealth inequality accounts for major problems for both individual and societal health. It might be time to admit that there is a critical "bug" in our culture\'s incentivization "software" that has led to the formation of this ever growing wealth chasm between the top 1% and the rest of us. We pay for luxury at the expense of every day necessities. The more we have, the less it seems to matter as the commodification of life continues.',
      'This shirt design is an ironic quiet protest against the meaningless wealth symbology that pervades modern life. Repurposing, stealing, the status symbols of the elite in a bit of harmless satire isn\'t a crime... is it?'
    ]
  }
]

function App() {
  const [showAbout, setShowAbout] = useState(false);
  const [showCart, setShowCart] = useState(false);
  const [cartItems, setCartItems] = useState([]);
  const [showLearn, setShowLearn] = useState(false);
  const [selectedProduct, setSelectedProduct] = useState()

  const handleRemoveItem = (itemId, itemType) => {
    setCartItems(prevItems => {
      return prevItems.filter(item => !(item.id === itemId && item.type === itemType))
    });
  };

  const handleAddCartItem = (itemId) => {
    setCartItems(prevItems => {
      let itemType = document.getElementById(`${itemId}-type`).value
      let previouslyAddedItem = prevItems.find(item => (item.id === itemId && item.type === itemType))

      return (
        previouslyAddedItem ?
        prevItems.map(item =>
          (item.id === itemId && item.type === itemType)
            ? { ...item, quantity: previouslyAddedItem.quantity + 1 }
            : item
        )
        :
        [...prevItems, {...products[itemId - 1], type: itemType, quantity: 1} ]
      )
    })
  };

  const handleClearCart = () => {
    setCartItems([]);
  };

  const handleCheckout = () => {
    console.log('Proceeding to checkout...');
  };

  const handleUpdateQuantity = (itemId, itemType, newQuantity) => {
    setCartItems(prevItems => {
      if (newQuantity <= 0) {
        // Remove item if quantity is 0 or less
        return prevItems.filter(item => !(item.id === itemId && item.type === itemType));
      }
      
      // Update quantity for the specific item
      return prevItems.map(item =>
        (item.id === itemId && item.type === itemType)
          ? { ...item, quantity: newQuantity }
          : item
      );
    });
  };

  return (
    <div style={{margin: '0 auto'}} className="App">
      <AboutWindow 
        isVisible={showAbout} 
        onClose={() => setShowAbout(false)} 
      />
      <header className="App-header">
        <h1 style={{marginBottom: '.3em'}} className="glitch">
          aware.house
        </h1>
        <div style={{display: 'flex', flexDirection: 'row', justifyContent: 'center', marginBottom: '2rem'}}>
          <a target="_blank" rel="noreferrer" href="https://instagram.com/awarehouse.link"><img style={{margin: '0 .2em'}} height="28" width="28" src="/pixel-ig.png" alt="ig" /></a>
          <img 
            style={{margin: '0 .2em', cursor: 'pointer'}} 
            height="28" 
            width="28" 
            src="/pixel-globe.png" 
            alt="globe" 
            onClick={() => setShowAbout(true)}
          />
          <CartBadge>
            <img 
              style={{margin: '0 .2em', cursor: 'pointer'}} 
              height="28" 
              width="28" 
              src="/cart.png" 
              alt="globe" 
              onClick={() => setShowCart(true)}
            />
            {cartItems.length > 0 && (
              <Badge>{cartItems.reduce((sum, item) => sum + item.quantity, 0)}</Badge>
            )}
          </CartBadge>
          <LearnMore 
            show={showLearn}
            onClose={() => setShowLearn(false)}
            itemInfo={selectedProduct} 
            onAddToCart={() => console.log('adding to cart')}
          />
          <Sidebar 
            show={showCart}
            onClose={() => setShowCart(false)}
            cartItems={cartItems}
            onRemoveItem={handleRemoveItem}
            onClearCart={handleClearCart}
            onCheckout={handleCheckout}
            onUpdateQuantity={handleUpdateQuantity}
          />
        </div>
      </header>
      
      <ProductGrid>
        {products.map((product, i) => (
          <ProductCard key={product.id}>
            {product.file.endsWith('.glb') ?
            <model-viewer alt="K cap" src={product.file} ar environment-image="" poster="" shadow-intensity="1" camera-controls touch-action="pan-y"></model-viewer>
            :
            <ProductImage src={product.file} alt={product.name} />
          }
            <ProductTitle>{product.name}</ProductTitle>
            <div>{product.price}</div>
            <Select id={`${product.id}-type`} defaultValue={product.types[0]}>
              <option value="" disabled>Select Size</option>
              {product.types.map((type, i) => <option value={type}>{type}</option>)}
            </Select>
            <div>
              <Button onClick={() => {
                debugger
                setSelectedProduct(productInfo[i])
                setShowLearn(true)
              }}>Learn More</Button>
              <Button disabled onClick={() => handleAddCartItem(product.id)}>Sold Out</Button>
            </div>
          </ProductCard>
        ))}
        
      </ProductGrid>
      <Footer />
    </div>
  );
}

export default App;